import type { SVGProps } from 'react';
const SvgDomainDisabled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#domain_disabled_svg__a)">
      <path
        fill="currentColor"
        d="M8 5h2v2h-.9L12 9.9V9h8v8.9l2 2V7H12V3H5.1L8 5.9V5Zm8 6h2v2h-2v-2ZM1.3 1.8.1 3.1 2 5v16h16l3 3 1.3-1.3-21-20.9ZM6 19H4v-2h2v2Zm0-4H4v-2h2v2Zm0-4H4V9h2v2Zm4 8H8v-2h2v2Zm0-4H8v-2h2v2Zm2 4v-2h2l2 2h-4Z"
      />
    </g>
    <defs>
      <clipPath id="domain_disabled_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDomainDisabled;
